import { createFileRoute, redirect } from "@tanstack/react-router"

// The admin area used to live under /platform; old bookmarks land here.
export const Route = createFileRoute("/_app/platform/")({
  beforeLoad: () => redirect({ to: "/admin", replace: true, throw: true }),
})
